import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import Procurement from "../../components/procurement-management";

function ProcurementPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Aviation Procurement & Supply Chain Expertise | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb
        title={"Aviation Procurement & Supply Chain Expertise"}
        t={t}
      />
      <Procurement />
    </>
  );
}

export default ProcurementPage;
